import * as Keycloak from 'keycloak-js'

// state
const state = {
    keycloak: null
};

// getters
const getters = {};

// actions
const actions = {
    init({ commit, state }) {
        commit('setKeycloak', Keycloak({
            realm: process.env.VUE_APP_KEYCLOAK_REALM,
            url: process.env.VUE_APP_KEYCLOAK_URL,
            clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID
        }));

        return state.keycloak.init({
            onLoad: 'login-required',
            promiseType: 'native',
            // Only activate on domains with localticketing.de as otherwise the iFrame will make a infinite loop
            checkLoginIframe: window.location.origin.endsWith('localticketing.de')
        });
    }
};

// mutations
const mutations = {
    setKeycloak(state, keycloak) {
        state.keycloak = keycloak;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
